import React, { useEffect, useState } from "react";
import axios from "axios";
import { Authorization } from "../../Context/Authorization";
import "./ViewBalanceTable.css";
import * as XLSX from "xlsx";
const thStyle = { padding: "10px 12px", fontSize: 12, fontWeight: 700, color: "#2D3748", background: "#F7FAFC", border: "1px solid #E2E8F0", textAlign: "left" };
const tdStyle = { padding: "9px 12px", fontSize: 12, color: "#4A5568", border: "1px solid #E2E8F0" };
const ClosingBalanceCircleData = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const Api = process.env.REACT_APP_API;

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const res = await axios.get(
                `${Api}/api/closing-balance/circle-jfmc`,
                Authorization()
            );
            setData(res.data || []);
        } catch (err) {
            console.error("Error fetching closing balance", err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="rwr-loading">Loading...</div>;

    // 🔹 Group by circle
    const grouped = data.reduce((acc, item) => {
        if (!acc[item.circleName]) acc[item.circleName] = [];
        acc[item.circleName].push(item);
        return acc;
    }, {});
    const exportClosingBalanceCircle = (data) => {
        if (!data || data.length === 0) {
            alert("No data to export");
            return;
        }

        const grouped = data.reduce((acc, item) => {
            if (!acc[item.circleName]) acc[item.circleName] = [];
            acc[item.circleName].push(item);
            return acc;
        }, {});

        const sheetData = [];

        // 🔹 Title Row
        sheetData.push([
            "Closing Balance (Circle Wise)"
        ]);

        sheetData.push([]); // empty row

        let circleIndex = 1;

        Object.entries(grouped).forEach(([circle, items]) => {
            let circleTotal = items.reduce(
                (sum, i) => sum + (i.totalAmount || 0),
                0
            );

            // 🔥 Circle Title Row (like UI)
            sheetData.push([
                `${circleIndex}. ${circle} — ₹${circleTotal.toLocaleString("en-IN")}`
            ]);

            // 🔹 Table Header
            sheetData.push([
                "#",
                "JFMC Type",
                "VFC Count",
                "Cash",
                "Bank",
                "Total",
            ]);

            // 🔹 Table Rows
            items.forEach((item, idx) => {
                sheetData.push([
                    idx + 1,
                    item.jfmcTypeName,
                    item.vfcWithBalance,
                    item.totalCash || 0,
                    item.totalBank || 0,
                    item.totalAmount || 0,
                ]);
            });

            // 🔹 Empty row after each circle
            sheetData.push([]);

            circleIndex++;
        });

        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

        // 🔥 Auto column width
        worksheet["!cols"] = [
            { wch: 5 },
            { wch: 20 },
            { wch: 15 },
            { wch: 15 },
            { wch: 20 },
            { wch: 20 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Closing Balance");

        XLSX.writeFile(workbook, "Closing_Balance_Circle.xlsx");
    };
    return (
        <div className="card p-3" style={{ padding: 16, overflowX: "auto" }}>
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
                <button
                    className="btn btn-success btn-sm"
                    onClick={() => exportClosingBalanceCircle(data)}
                >
                    Export Excel
                </button>
            </div>
            <h5>
                Closing Balance (Circle Wise) As on{" "}
                {data.length > 0
                    ? new Date(data[0]?.closingDate || new Date()).toLocaleDateString(
                        "en-GB",
                        {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                        }
                    )
                    : "N/A"}
            </h5>

            {Object.entries(grouped).map(([circle, items], cIndex) => {
                const totalAmount = items.reduce(
                    (sum, i) => sum + (i.totalAmount || 0),
                    0
                );

                return (
                    <div key={circle} style={{ marginBottom: 25 }}>

                        {/* 🔹 Circle Title */}
                        <h6 style={{ margin: "12px 0", color: "#2D3748" }}>
                            {cIndex + 1}. {circle} — ₹{totalAmount.toLocaleString("en-IN")}
                        </h6>

                        {/* 🔹 Table */}
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>
                                    <th style={thStyle}>#</th>
                                    <th style={thStyle}>JFMC Type</th>
                                    <th style={thStyle}>VFC Count</th>
                                    <th style={thStyle}>Cash</th>
                                    <th style={thStyle}>Bank</th>
                                    <th style={thStyle}>Total</th>
                                </tr>
                            </thead>

                            <tbody>
                                {items.map((item, index) => (
                                    <tr key={index}>
                                        <td style={tdStyle}>{index + 1}</td>

                                        <td style={tdStyle}>{item.jfmcTypeName}</td>

                                        <td style={tdStyle}>{item.vfcWithBalance}</td>

                                        <td style={{ ...tdStyle, fontWeight: 600 }}>
                                            ₹{item.totalCash?.toLocaleString("en-IN")}
                                        </td>

                                        <td style={{ ...tdStyle, fontWeight: 600 }}>
                                            ₹{item.totalBank?.toLocaleString("en-IN")}
                                        </td>

                                        <td style={tdStyle}>
                                            ₹{item.totalAmount?.toLocaleString("en-IN")}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                );
            })}
        </div>
    );
};

export default ClosingBalanceCircleData;